export default "__VITE_ASSET__BOhLkfJN__"